'use client'

import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useState } from 'react'

import { mapQueries, TMarkerSearchParams } from '@/entities/map'
import { SearchMap, useMapSearchParams, Webview } from '@/features/search-map'
import { BridgeProvider } from '@/shared/lib'
import { TLanguage } from '@/shared/model'

type Props = {
  language: TLanguage
}

export const WebviewSearchPage = ({ language }: Props) => {
  const queryClient = useQueryClient()
  const [mapInitialized, setMapInitialized] = useState(false)

  const { width, height, userId } = useMapSearchParams({
    pathname: '/webview/guest/search',
  })

  const getMarkers = useCallback(
    async (params: TMarkerSearchParams) => {
      const markers = await queryClient.fetchQuery({
        ...mapQueries.markerList({
          ...params,
          ...(userId && { uid: userId }),
        }),
      })

      return markers
    },
    [queryClient, userId],
  )

  const handleMapInitialized = useCallback(() => {
    setMapInitialized(true)
  }, [])

  return (
    <BridgeProvider>
      <div
        className="webview-container relative h-[600px] w-full flex-grow overflow-hidden"
        style={{
          ...(width && { width: `${width}px` }),
          ...(height && { height: `${height}px` }),
        }}
      >
        <SearchMap
          language={language}
          getMarkers={getMarkers}
          onInitialized={handleMapInitialized}
        />
      </div>
      <Webview mapInitialized={mapInitialized} />
    </BridgeProvider>
  )
}
